export const POSTAL_CODE_MAX_LENGTHS = {
  // A
  AD: 5,  // Andorra
  AE: 0,  // United Arab Emirates
  AF: 4,  // Afghanistan
  AG: 0,  // Antigua and Barbuda
  AI: 7,  // Anguilla
  AL: 4,  // Albania
  AM: 4,  // Armenia
  AO: 0,  // Angola
  AQ: 0,  // Antarctica
  AR: 8,  // Argentina
  AS: 5,  // American Samoa (postal_code only)
  AT: 4,  // Austria
  AU: 4,  // Australia
  AW: 0,  // Aruba
  AX: 5,  // Åland Islands

  // B
  BA: 5,  // Bosnia and Herzegovina
  BB: 7,  // Barbados
  BD: 4,  // Bangladesh
  BE: 4,  // Belgium
  BF: 0,  // Burkina Faso
  BG: 4,  // Bulgaria
  BH: 4,  // Bahrain
  BI: 0,  // Burundi
  BJ: 0,  // Benin
  BL: 5,  // Saint Barthélemy
  BM: 4,  // Bermuda
  BN: 6,  // Brunei
  BO: 0,  // Bolivia
  BQ: 0,  // Caribbean Netherlands
  BR: 9,  // Brazil
  BS: 0,  // Bahamas
  BT: 5,  // Bhutan
  BV: 0,  // Bouvet Island
  BW: 0,  // Botswana
  BY: 6,  // Belarus
  BZ: 0,  // Belize

  // C
  CA: 7,  // Canada: A1A 1A1
  CC: 4,  // Cocos (Keeling) Islands
  CD: 7,  // DR Congo
  CF: 0,  // Central African Republic
  CG: 0,  // Republic of Congo
  CH: 4,  // Switzerland
  CI: 0,  // Côte d'Ivoire
  CK: 0,  // Cook Islands
  CL: 7,  // Chile
  CM: 0,  // Cameroon
  CN: 6,  // China
  CO: 6,  // Colombia
  CR: 5,  // Costa Rica
  CU: 5,  // Cuba
  CV: 4,  // Cabo Verde
  CW: 0,  // Curaçao
  CX: 4,  // Christmas Island
  CY: 4,  // Cyprus
  CZ: 5,  // Czech Republic

  // D
  DE: 5,  // Germany
  DJ: 5,  // Djibouti
  DK: 4,  // Denmark
  DM: 0,  // Dominica
  DO: 5,  // Dominican Republic
  DZ: 5,  // Algeria

  // E
  EC: 6,  // Ecuador
  EE: 5,  // Estonia
  EG: 7,  // Egypt
  EH: 5,  // Western Sahara
  ER: 0,  // Eritrea
  ES: 5,  // Spain
  ET: 4,  // Ethiopia

  // F
  FI: 5,  // Finland
  FJ: 0,  // Fiji
  FK: 8,  // Falkland Islands
  FM: 5,  // Micronesia
  FO: 3,  // Faroe Islands
  FR: 5,  // France

  // G
  GA: 2,  // Gabon
  GB: 7,  // United Kingdom
  GD: 0,  // Grenada
  GE: 4,  // Georgia
  GF: 5,  // French Guiana
  GG: 7,  // Guernsey
  GH: 6,  // Ghana
  GI: 5,  // Gibraltar
  GL: 4,  // Greenland
  GM: 0,  // Gambia
  GN: 3,  // Guinea
  GP: 5,  // Guadeloupe
  GQ: 0,  // Equatorial Guinea
  GR: 5,  // Greece
  GS: 8,  // South Georgia and South Sandwich Islands
  GT: 5,  // Guatemala
  GU: 5,  // Guam
  GW: 4,  // Guinea-Bissau
  GY: 7,  // Guyana

  // H
  HK: 6,  // Hong Kong
  HM: 4,  // Heard Island and McDonald Islands
  HN: 5,  // Honduras
  HR: 5,  // Croatia
  HT: 6,  // Haiti
  HU: 4,  // Hungary

  // I
  ID: 5,  // Indonesia
  IE: 7,  // Ireland
  IL: 7,  // Israel
  IM: 7,  // Isle of Man
  IN: 6,  // India
  IO: 8,  // British Indian Ocean Territory
  IQ: 5,  // Iraq
  IR: 10, // Iran
  IS: 3,  // Iceland
  IT: 5,  // Italy

  // J
  JE: 7,  // Jersey
  JM: 2,  // Jamaica
  JO: 5,  // Jordan
  JP: 7,  // Japan

  // K
  KE: 5,  // Kenya
  KG: 6,  // Kyrgyzstan
  KH: 6,  // Cambodia
  KI: 6,  // Kiribati
  KM: 0,  // Comoros
  KN: 6,  // Saint Kitts and Nevis
  KP: 0,  // North Korea
  KR: 5,  // South Korea
  KW: 5,  // Kuwait
  KY: 8,  // Cayman Islands
  KZ: 7,  // Kazakhstan
  XK: 5,  // Kosovo

  // L
  LA: 5,  // Laos
  LB: 9,  // Lebanon
  LC: 7,  // Saint Lucia
  LI: 4,  // Liechtenstein
  LK: 5,  // Sri Lanka
  LR: 4,  // Liberia
  LS: 3,  // Lesotho
  LT: 5,  // Lithuania
  LU: 4,  // Luxembourg
  LV: 4,  // Latvia
  LY: 0,  // Libya

  // M
  MA: 5,  // Morocco
  MC: 5,  // Monaco
  MD: 4,  // Moldova
  ME: 5,  // Montenegro
  MF: 5,  // Saint Martin
  MG: 3,  // Madagascar
  MH: 5,  // Marshall Islands
  MK: 4,  // North Macedonia
  ML: 0,  // Mali
  MM: 7,  // Myanmar
  MN: 5,  // Mongolia
  MO: 6,  // Macao
  MP: 5,  // Northern Mariana Islands
  MQ: 5,  // Martinique
  MR: 0,  // Mauritania
  MS: 7,  // Montserrat
  MT: 7,  // Malta
  MU: 5,  // Mauritius
  MV: 5,  // Maldives
  MW: 6,  // Malawi
  MX: 5,  // Mexico
  MY: 5,  // Malaysia
  MZ: 4,  // Mozambique

  // N
  NA: 5,  // Namibia
  NC: 5,  // New Caledonia
  NE: 4,  // Niger
  NF: 4,  // Norfolk Island
  NG: 6,  // Nigeria
  NI: 5,  // Nicaragua
  NL: 7,  // Netherlands
  NO: 4,  // Norway
  NP: 5,  // Nepal
  NR: 5,  // Nauru
  NU: 4,  // Niue
  NZ: 4,  // New Zealand

  // O
  OM: 3,  // Oman

  // P
  PA: 4,  // Panama
  PE: 5,  // Peru
  PF: 5,  // French Polynesia
  PG: 3,  // Papua New Guinea
  PH: 4,  // Philippines
  PK: 5,  // Pakistan
  PL: 5,  // Poland
  PM: 5,  // Saint Pierre and Miquelon
  PN: 8,  // Pitcairn
  PR: 5,  // Puerto Rico
  PS: 8,  // Palestine
  PT: 7,  // Portugal
  PW: 5,  // Palau
  PY: 6,  // Paraguay

  // Q
  QA: 0,  // Qatar

  // R
  RE: 5,  // Réunion
  RO: 6,  // Romania
  RS: 6,  // Serbia
  RU: 6,  // Russia
  RW: 0,  // Rwanda

  // S
  SA: 5,  // Saudi Arabia
  SB: 0,  // Solomon Islands
  SC: 0,  // Seychelles
  SD: 5,  // Sudan
  SE: 5,  // Sweden
  SG: 6,  // Singapore
  SH: 8,  // Saint Helena
  SI: 4,  // Slovenia
  SJ: 4,  // Svalbard and Jan Mayen
  SK: 5,  // Slovakia
  SL: 0,  // Sierra Leone
  SM: 5,  // San Marino
  SN: 5,  // Senegal
  SO: 0,  // Somalia
  SR: 0,  // Suriname
  SS: 0,  // South Sudan
  ST: 0,  // São Tomé and Príncipe
  SV: 4,  // El Salvador
  SX: 0,  // Sint Maarten
  SY: 0,  // Syria
  SZ: 4,  // Eswatini

  // T
  TC: 8,  // Turks and Caicos
  TD: 0,  // Chad
  TF: 5,  // French Southern Territories
  TG: 0,  // Togo
  TH: 5,  // Thailand
  TJ: 6,  // Tajikistan
  TK: 0,  // Tokelau
  TL: 7,  // Timor-Leste
  TM: 6,  // Turkmenistan
  TN: 4,  // Tunisia
  TO: 0,  // Tonga
  TR: 5,  // Türkiye
  TT: 6,  // Trinidad and Tobago
  TV: 0,  // Tuvalu
  TW: 5,  // Taiwan
  TZ: 5,  // Tanzania

  // U
  UA: 5,  // Ukraine
  UG: 5,  // Uganda
  UM: 0,  // U.S. Minor Outlying Islands
  US: 5,  // United States - postal_code only
  UY: 5,  // Uruguay
  UZ: 6,  // Uzbekistan

  // V
  VA: 5,  // Vatican City
  VC: 6,  // Saint Vincent and the Grenadines
  VE: 4,  // Venezuela
  VG: 6,  // British Virgin Islands
  VI: 5,  // U.S. Virgin Islands

  // W
  WF: 5,  // Wallis and Futuna
  WS: 6,  // Samoa

  // Y
  YE: 0,  // Yemen
  YT: 5,  // Mayotte

  // Z
  ZA: 4,  // South Africa
  ZM: 5,  // Zambia
  ZW: 0   // Zimbabwe
};

export function getPostalCodeMaxLength(countryCode) {
  return POSTAL_CODE_MAX_LENGTHS[countryCode?.toUpperCase()];
}

export function setPostalCodeMaxLength(input, countryCode) {
  if (!input) return;

  const maxLength = getPostalCodeMaxLength(countryCode);

  if (maxLength === undefined || maxLength === 0) {
    input.removeAttribute("maxlength");
    return;
  }

  input.setAttribute("maxlength", maxLength);

  if (input.value.length > maxLength) {
    input.value = input.value.slice(0, maxLength);
  }
}